export default __webpack_public_path__ + "static/media/Stalker's Bracers of Charred Earth.6eeadd2b.jpg";